import React from 'react';
import horizontalLogo from '../assets/LandingPageHorizontalLogo.png';
import LandingWaitingListModal from './LandingWaitingListModal';

const LandingHero: React.FC = () => {
  return (
    <section className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-5 py-16 md:grid-cols-2">
      <div className="rounded-3xl bg-white/90 p-8 shadow-2xl">
        <h1 className="text-4xl font-extrabold text-[#2f2f2d] md:text-6xl">
          Stop losing hours to DMs and no-shows.
        </h1>
        <p className="mt-4 text-lg text-[#2f2f2d]">
          InkVoyd puts your booking pipeline &mdash; forms, deposits, reminders,
          and last-minute re-fills &mdash; behind one link for independent
          tattoo artists, so you spend more time tattooing and less time on
          admin.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <LandingWaitingListModal
            title="Join the InkVoyd waiting list"
            buttonText="Join the waiting list"
          />
          <a
            href="#how"
            className="inline-flex items-center justify-center rounded-2xl border border-[#2f2f2d]/40 px-5 py-3 font-semibold text-[#2f2f2d] hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#2f2f2d]"
          >
            See how it works
          </a>
        </div>
        <p className="mt-3 text-xs text-[#2f2f2d]">
          Limited availability &mdash; we&apos;re looking for tattoo artists.
        </p>
      </div>
      <div className="flex min-h-[260px] items-center justify-center">
        <img
          src={horizontalLogo}
          alt="InkVoyd logo"
          className="h-64 w-full rounded-3xl bg-white/30 shadow-inner"
        />
      </div>
    </section>
  );
};

export default LandingHero;
